<template>
  <div class="settings scrollbar">
    <div class="row">
      <div class="col-4 flex-col">
        <h1>Subscription</h1>
        <span class="header">Current Plan</span>
        <span >
            {{ currentPlanString }}
        </span>
        <span class="header">Scheduled Change</span>
        <span >
          {{ newPlanString }}
        </span>
      </div>
      <!-- <HelpTip class="col-4" v-if="isCustom" >
        Custom Plan with tailored quota limits.
      </HelpTip>
      <div v-else>
      <HelpTip class="col-4" if="paymentInfo" >
        {{ LastPayment }}.
         {{ NexPayment }} . 
        Cancel a subscription by switching to Free tier. Cancelling subscription will take into effect on {{ NexPayment }}
      </HelpTip>
       </div> -->
      
    </div>
    <br>
    <div class="row">
      <div class="col-4 flex-col">   
        <div>
          Card List
          <button class="button add-card" @click="setupCard()">Add Credit Card</button>
        </div>
        <div class="row-wait">
          <div >
            <CreditCardList :cardList="paymentInfo?paymentInfo['cards']:[]"  @card_updated="deleteCardHandler()" />
          </div>
          <div v-if="loading">
            <div id="loading-visualization" class="wait"><div class="lds-ring"><div /><div /><div /><div /></div></div>
          </div>
        </div>
      </div>
      <div class="col-6 term-selector-cont flex-col" v-if="!planSelected">
        <div v-if="isAdmin && paymentInfo" class="term-selector">
          <TabsSelector
            v-model="planTerm"
            :items="planTerms"
          />
         
        </div>
      </div>
    </div>
    <br>
    <SubscriptionConfirm v-if="planSelected" 
    
      :current_plan="paymentInfo?paymentInfo.plan_name:''"
      :current_term="paymentInfo?paymentInfo.current.term:''"
      :current_end="formattedEnd"
      :new_plan="planNew.title"
      :new_term="planNew.term"
      :new_start="planNew.start"
      :new_payment="'USD $'+planNew.amount+'.00'"
    
      @selection_end="closeSelection"
    />
   <PricingSection v-else
            :recommended="'team'"
            :currentPlan="paymentInfo ? paymentInfo.current.plan : ''"
            :currentPlanTerm="paymentInfo ? paymentInfo.current.term : ''"
            :planTerm="planTerm"
            @plan_clicked="planClickedHandler"
          />
  </div>

  <FeedbackModal ref="feedbackModal" />
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import PricingSection from '@/components/subscription/PricingSection.vue';
import SubscriptionConfirm from '@/components/subscription/SubscriptionConfirm.vue';
import TabsSelector from '@/components/TabsSelector.vue';
import FeedbackModal from '@/components/FeedbackModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import CreditCardList from '@/components/subscription/CreditCardList.vue';
import HelpTip from '@/components/HelpTip.vue';

import { useToast } from 'vue-toast-notification';

const $toast = useToast();

export default {
  name: 'OrgSubscription',
  components: {
    PricingSection,
    TabsSelector,
    FeedbackModal,
    ConfirmModal,
    CreditCardList,
    SubscriptionConfirm,
    HelpTip,
  },
 
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      users: [],
      org_name: '',
      plan:{},
      planNew:{},
      planTerms: [
        { value: 'short', display: "Monthly" },
        { value: 'year', display: "Save by choosing annual plan" },
      ],
      planName: "",
      isCustom:false,
      planTerm: "year",
      paymentInfo: null,
      confirmMessage: null,
      confirmNote: null,
      confirmMessageHeader: null,
      buttonClass: null,
      buttonText: "",
      loading:false,
      planSelected:false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    isAdmin() {
      return this.user && this.user.role === 'admin';
    },
    isSuper() {
      return this.user && this.user.role === 'super';
    },
    newPlanString() {

      if (!this.paymentInfo) return "";
      if (this.paymentInfo.new.plan=="") return "No Plan Scheduled";

      var str=this.paymentInfo.new.title + ' per ' + this.paymentInfo.new.term+' starting '+ this.formattedNewStart;  
      return str;
    },

    currentPlanString() {
      if(!this.paymentInfo) return "";

      if(this.paymentInfo.current.plan.includes('free')  ) return "Public Plan";

      if(this.paymentInfo.is_custom) 
      {
        return  this.paymentInfo.current.title + "  (Custom)"
      }


      if(this.paymentInfo.new.plan)
      {
        return this.paymentInfo.current.title+ ' per ' + this.paymentInfo.current.term +' ending '+ this.formattedEnd; 
      } else {
        return this.paymentInfo.current.title+ ' per ' + this.paymentInfo.current.term ; 
      }
    },

   NexPayment() {
      if (this.paymentInfo && this.paymentInfo.next_payment) {
        if (this.paymentInfo.next_payment.amount_remaining>0) {
          return "Next Payment of USD "+this.paymentInfo.next_payment.amount_remaining + " is will be charged " + this.formatBillDate(this.paymentInfo.next_payment.date_to_pay) ;
        }  { return "No upcoming payment"

        }
      } else {
        return "";
      }
    },
    LastPayment() {
      if (this.paymentInfo && this.paymentInfo.last_payment) {
        return "USD "+ this.paymentInfo.last_payment.amount_paid + " was paid on " + this.formatBillDate(this.paymentInfo.last_payment.date_paid) ;
      } else {
        return "";
      }
    },

    formattedStart() {
      if (this.paymentInfo) {
        return this.formatBillDate(this.paymentInfo.current.start);
      } else {
        return "";
      }
    },
    formattedEnd() {
      if (this.paymentInfo) {
        return this.formatBillDate(this.paymentInfo.current.end);
      } else {
         return 'Never';
      }
    },
     formattedNewStart() {
      if (this.paymentInfo) {
        return this.formatBillDate(this.paymentInfo.new.start);
      } else {
         return '-';
      }
    },
     formattedNewEnd() {
      if (this.paymentInfo) {
        return this.formatBillDate(this.paymentInfo.new.end);
      } else {
         return 'Never';
      }
    },
  },
  async mounted() {
    await this.refreshPage();
  },
  methods: {
    closeSelection(mode){
      this.planSelected=false;
      if (mode=='ok') {
        this.subscribe();
      }
    },
    deleteCardHandler() {
      this.getPaymentInfo();
    },
    formatBillDate(d) {
      if (!d) {
        return null;
      }
      const date = new Date(d);
      if (date.getUTCFullYear() === 1 && date.getUTCMonth() === 0 && date.getUTCDate() === 1) {
        return null;
      }
      const options = { month: 'short' }; // gives "Jan", "Feb", etc.
      const month = new Intl.DateTimeFormat('en-US', options).format(date);
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    },
    async refreshPage() {
      await this.getOrg();
      await this.getPaymentInfo();
    },
    async planClickedHandler(plan) {
      this.planNew.term=plan.term;
      this.planNew.plan=plan.name;
      this.planNew.title=plan.title;

      //TODO update the plan info from BE
      if(this.paymentInfo && this.paymentInfo.immediate_plans) {
        if (this.paymentInfo.immediate_plans.includes(plan.name)) {
          this.planNew.start=this.formatBillDate(Date.now());
        } else {
          this.planNew.start=this.formatBillDate(this.paymentInfo.current.end);
        }
      }

      
      this.planNew.amount="";

      this.planSelected=true;
    },
    async setupCard() {
      const dsConn = new DatastoreConnect();
      const success_url = `${window.location.origin}/admin/subscription`;
      const fail_url = `${window.location.origin}/admin/payment_fail`;
      this.loading=true;
      const ret = await dsConn.setupCard({ success: success_url, fail: fail_url});

      if (ret.result) {
        const url = ret.result["url"];
        if (url.includes("admin/transactions")) {
          $toast.open({
            queue: true,
            duration: 0,
            dismissible: true,
            message: `Successfully updated plan`,
            type: "success",
            position: "top",
          });
          this.refreshPage();
        } else if (url.includes("admin/payment_fail")) {
          $toast.open({
            queue: true,
            duration: 0,
            dismissible: true,
            message: `Error changing plan`,
            type: "error",
            position: "top",
          });
        } else {
          window.location.replace(url);
        }
      } else {
        let msg = `Error changing plan`;
        if (ret.error) {
          msg = ret.error.message;
        }

        const requestRet = await dsConn.requestFunds({
          reason: 'Add Credit Card',
          message: msg,
        });

        if (requestRet.result) {
          $toast.open({
            queue: true,
            duration: 0,
            dismissible: true,
            message: 'We will be happy to assist you to get more funds or plans upgrade. A member of our team will contact you shortly.',
            type: 'success',
            position: 'top',
          });
          this.loading = false;
          return;
        }

        if (requestRet.error) {
          msg = requestRet.error.message;
        }

         $toast.open({
            queue: true,
          duration: 0,
            dismissible: true,
            message: msg,
            type: "error",
            position: "top",
      });
      this.loading=false;
    }
  },
    async subscribe( ) {

      const plan=this.planNew.plan;
      const term=this.planNew.term;
      const currentPlan = this.currentPlanString;
      
      const dsConn = new DatastoreConnect();
      const success_url = `${window.location.origin}/admin/transactions`;
      const fail_url = `${window.location.origin}/admin/payment_fail`;
      this.loading=true;
      this.paymentInfo =null;
      const ret = await dsConn.paymentSubscribe({
        plan, term, success: success_url, fail: fail_url,
      });

      if (ret.result) {
          this.paymentInfo = ret.result;
          let term=this.paymentInfo.current.term;
          if (term!='year') term='short';
          this.planTerm=term;
          $toast.open({
            queue: true,
            duration: 0,
            dismissible: true,
            message: 'Successfully updated plan: '+this.paymentInfo.new.plan.toUpperCase(),
            type: "success",
            position: "top",
          });
          await this.refreshPage();
      } else if (ret.error) {
        var message='Error changing plan';
        if (ret.error.message) {
          message=ret.error.message;
        }

        const requestRet = await dsConn.requestFunds({
          reason: 'Plan Change Error',
          message: `Plan change from ${currentPlan} to New plan ${this.planNew.title}, ` + message,
        });

        if (message.includes('Payment Gateway disabled')) {
            $toast.open({
              queue: true,
              duration: 0,
              dismissible: true,
              message: `We are excited that you are changing your plan from ${currentPlan} to ${this.planNew.title}. A member of our team will contact you shortly.`,
              type: 'success',
              position: 'top',
            });
            await this.refreshPage();
            this.loading=false;
            return;
          }
        else 
      {
          $toast.open({
            queue: true,
            duration: 0,
            dismissible: true,
            message: message,
            type: "error",
            position: "top",
        });
      }
      await this.refreshPage();
      this.loading=false;
    }
  },
    openFeedbackModal() {
      this.$refs.feedbackModal.showModal();
    },
    async getOrg() {
      await this.dsConn.getOrg({ organization_id: this.user.organization_id })
        .then((data) => {
          if (data.result) {
            this.org_name = data.result.name;
          } else {
            throw new Error(data.error.message);
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 0,
            dismissible: true,
            message: `${e}`,
            type: "error",
            position: "top",
          });
        });
    },
   

     async getPaymentInfo() {
      this.loading=true;
      await this.dsConn.getPaymentInfo()
        .then((data) => {
          this.loading=false;
          if (data.result) {
            this.paymentInfo = data.result;
            this.isCustom=this.paymentInfo.is_custom;
            let term=this.paymentInfo.current.term;
            if (term!='year') term='short';
            this.planTerm=term;
          } else {
            throw new Error(data.error.message);
          }
        })
        .catch((e) => {
          $toast.open({
            queue: true,
            duration: 0,
            dismissible: true,
            message: `${e}`,
            type: "error",
            position: "top",
          });
        });
        this.loading=false;
    },
    navigateToEditOrg() {
      this.$router.push({ name: 'admin.organization.editorg', query: { org: this.user.organization_id } });
    },
  },
};
</script>
<style lang="scss" scoped>

.settings {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 400px;
  height: 100%;
  padding: 30px;
  overflow-y: auto;
}

.header {
  font-size: 1.2rem;
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.header-2 {
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.add-card {
  border-radius: 6px;
  padding: 6px;
  margin-left: 20px
}

.subtitle {
  font-size: 0.9rem;
}

.wait {
  position: relative !important;
  width: 100px  !important;
}

.row-wait {
 display: flex;
  flex-direction: row;
}

.term-selector-cont {
  position: relative;
}
.term-selector {
  min-width: 300px;
  position: absolute;
  bottom: 0px;
}

</style>
